// @flow

import { css } from '@emotion/react'
import styled from '@emotion/styled'
import * as React from 'react'

import { media } from '@toggl/style'

type Props = {
  children: React.Node,
  background?: string,
}

export default function Large({ children, background }: Props) {
  return (
    <Root background={background}>
      <CornerShapes />
      {children}
    </Root>
  )
}

const CornerShapes = (props: any) => (
  <svg
    viewBox="0 0 321 222"
    css={css`
      width: 160px;
      transform: translateX(20px) translateY(56px);

      ${media.mq[1]} {
        position: absolute;
        width: 260px;
        left: 0;
        transform: translateX(-95px) translateY(-128px);
      }
    `}
    {...props}
  >
    <circle cx="152.84" cy="31.44" r="31.44" fill="#fff" />
    <circle cx="33.23" cy="211.77" r="10" fill="#e57cd8" />
    <polygon
      points="74.44 74.15 0.7 93.14 55.46 147.9 74.44 74.15"
      fill="#ffd67d"
    />
    <rect
      x="202"
      y="77.05"
      width="98.99"
      height="98.99"
      transform="matrix(0.82, 0.57, -0.57, 0.82, 118.27, -121.48)"
      fill="#f2bdec"
    />
  </svg>
)

const Root: React.ComponentType<any> = styled.div`
  display: flex;
  flex-direction: column;
  ${(p) => (p.background ? `background-color: ${p.background};` : '')}

  ${media.mq[1]} {
    position: relative;
    flex-direction: row;
    justify-content: center;
    margin: 140px auto 0 auto;
    max-width: 1200px;
  }
`
